import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { WorkGallery } from "@/components/site/WorkGallery";
import { useWorkItems } from "@/lib/use-work-items";
import { galleryCategoryForQuote } from "@/lib/work-gallery";

export function ServiceWorkGallery({ service }: { service: keyof typeof galleryCategoryForQuote }) {
  const category = galleryCategoryForQuote[service];
  const items = useWorkItems().filter((item) => item.category === category).slice(0, 3);

  return (
    <section className="border-y border-border bg-cream/85 backdrop-blur-sm py-16 md:py-24">
      <div className="container-x">
        <div className="mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="font-display text-3xl md:text-4xl">See our work</h2>
            <p className="mt-3 text-muted-foreground">Real examples from our cleaning team.</p>
          </div>
          <Link to="/our-work" className="inline-flex items-center gap-2 font-semibold text-primary">View all our work <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <WorkGallery items={items} />
      </div>
    </section>
  );
}